// extracted by mini-css-extract-plugin
module.exports = {"container":"TournamentsView_container__1nfUt","right":"TournamentsView_right__2j15k","left":"TournamentsView_left__3cQaj"};